<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Foreword#For">Foreword &amp; Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Int">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Long Beach, Land of the Tongva and <i>Joyas</i></span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Social Vagrants and Female Impersonators</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Hey Sailor, Are You New in Town?</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Here Come the Lesbians</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Briggs Brought Us Out</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">We Love a Parade</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">People Are Dying. Does Anyone Care?</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">LGBTQA Politics</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">So Many Rainbow Heroes</span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Creating a LGBTQA Cultural Center</span></td></tr>
<tr><td colspan="2"><span href="#/LGBTQ_resources#res" title="Link target outside of Sample">LGBTQ Resources</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3e60fadc